import i18next from "i18next"

import type { TFunction } from "i18next"

const CASE_STATUS_KEYS: Record<string, string> = {
  utkast: "tender.status.utkast",
  under_analys: "tender.status.under_analys",
  analyserad: "tender.status.analyserad",
  go: "tender.status.go",
  no_go: "tender.status.no_go",
}

const DOCUMENT_STATUS_KEYS: Record<string, string> = {
  uppladdad: "tender.documentStatus.uppladdad",
  indexeras: "tender.documentStatus.indexeras",
  indexerad: "tender.documentStatus.indexerad",
  fel: "tender.documentStatus.fel",
}

/** API / pipeline codes mapped under tender.status.codes.* */
const CODE_STATUS_KEYS: Record<string, string> = {
  pending: "tender.status.codes.pending",
  processing: "tender.status.codes.processing",
  completed: "tender.status.codes.completed",
  failed: "tender.status.codes.failed",
  met: "tender.status.codes.met",
  partial: "tender.status.codes.partial",
  missing: "tender.status.codes.missing",
  hog: "tender.risk.hog",
  medel: "tender.risk.medel",
  lag: "tender.risk.lag",
  kritisk: "tender.status.codes.kritisk",
  varning: "tender.status.codes.varning",
  normal: "tender.status.codes.normal",
  accepted: "tender.status.codes.accepted",
  deviated: "tender.status.codes.deviated",
  silent: "tender.status.codes.silent",
  aligned: "tender.status.codes.aligned",
  at_risk: "tender.status.codes.at_risk",
  conflict: "tender.status.codes.conflict",
  compliant: "tender.status.codes.compliant",
  minor_deviations: "tender.status.codes.minor_deviations",
  major_deviations: "tender.status.codes.major_deviations",
  go_med_forbehall: "tender.status.codes.go_med_forbehall",
  cautious_go: "tender.status.codes.cautious_go",
  ej_paborjat: "tender.status.codes.ej_paborjat",
  pagar: "tender.status.codes.pagar",
  klart: "tender.status.codes.klart",
  deviation: "tender.status.codes.deviation",
  not_addressed: "tender.status.codes.not_addressed",
  classified: "tender.status.codes.classified",
}

export function statusLabelI18nKey(status: string): string | undefined {
  if (Object.prototype.hasOwnProperty.call(CASE_STATUS_KEYS, status)) {
    return CASE_STATUS_KEYS[status]
  }
  if (Object.prototype.hasOwnProperty.call(DOCUMENT_STATUS_KEYS, status)) {
    return DOCUMENT_STATUS_KEYS[status]
  }
  if (Object.prototype.hasOwnProperty.call(CODE_STATUS_KEYS, status)) {
    return CODE_STATUS_KEYS[status]
  }
  return undefined
}

/** UI: resolve procurement / pipeline status codes to localized text. */
export function statusLabelT(status: string, t: TFunction): string {
  const key = statusLabelI18nKey(status)
  if (key) return t(key)
  return status
}

/**
 * Tender chat context blocks stay Swedish for the model regardless of UI locale.
 */
export function statusLabelSv(status: string): string {
  const key = statusLabelI18nKey(status)
  if (key) return i18next.getFixedT("sv")(key)
  return status
}

const CONTRACT_BID_POSITION_KEYS: Record<string, string> = {
  accepted: "tender.bidReview.riskTab.position.accepted",
  deviated: "tender.bidReview.riskTab.position.deviated",
  silent: "tender.bidReview.riskTab.position.silent",
}

/** Swedish labels for contract-term bid position (distinct from generic `accepted`). */
export function contractBidPositionLabelSv(position: string): string {
  const key = CONTRACT_BID_POSITION_KEYS[position]
  if (key) return i18next.getFixedT("sv")(key)
  return statusLabelSv(position)
}
